export default "__VITE_ASSET__7esg5tqW__"